import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import LoginPage from "./components/login";
import PricingModule from "./components/pricing";
import "./index.css";

function App() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
  const handle = async () => {
    try {
      const response = await instance.handleRedirectPromise();

      if (response?.account) {
        console.log("Login success:", response.account);
      }

      window.history.replaceState({}, document.title, "/");
    } catch (e) {
      console.error(e);
    }
  };

  handle();
}, [instance]);

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: ["openid", "profile", "User.Read"],
    });
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  if (!isAuthenticated) {
    return <LoginPage handleLogin={handleLogin} />;
  }
return (
    <div>
      <PricingModule />
    </div>
  );
}

export default App;